import { render } from "./ItemFooter.vue?vue&type=template&id=6e55a0b8&ts=true"
import script from "./ItemFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemFooter.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e55a0b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e55a0b8', __exports__)) {
    api.reload('6e55a0b8', __exports__)
  }
  
  module.hot.accept("./ItemFooter.vue?vue&type=template&id=6e55a0b8&ts=true", () => {
    api.rerender('6e55a0b8', render)
  })

}


export default __exports__